import { css } from '@emotion/css';

export const inputClasses = css`
  border-color: var(--border-error-dark);
  :hover {
    border-color: var(--border-error-dark);
  }
`;
